

<section class=" dds__dell-container dds__p-0 editor" style="resize: vertical; min-height: 34rem;">
  <div class="dds__dell-container-body dds__p-0">
    <div class="dds__row toolbar" style="resize: none">
      <div class="dds__col-12">
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Font Formats">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;" data-action="bold"
            data-tag-name="b" title="Bold" tabindex="0"
            aria-label="Bold button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__Bold">
                <title>Bold</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="italic" data-tag-name="i" title="Italic" tabindex="0"
            aria-label="Italic button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__Italic">
                <title>italic</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="underline" data-tag-name="u" title="Underline" tabindex="0"
            aria-label="Underline button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__underline">
                <title>underline</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="strikeThrough" data-tag-name="strike" title="Strike through" tabindex="0"
            aria-label="Strike through button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__strikethrough">
                <title>strikethrough</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Superscript & Subscript">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="superscript" data-tag-name="sup" title="Superscript" tabindex="0"
            aria-label="Superscript button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__superscript">
                <title>superscript</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="subscript" data-tag-name="sub" title="Subscript" tabindex="0"
            aria-label="Subscript button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__subscript">
                <title>subscript</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Content Justifications">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="justifyLeft" data-style="textAlign:left" title="Justify left" tabindex="0"
            aria-label="Justify left button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__align-left">
                <title>align-left</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="justifyCenter" data-style="textAlign:center" title="Justify center" tabindex="0"
            aria-label="Justify center button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__align-center">
                <title>align-center</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="justifyRight" data-style="textAlign:right" title="Justify right" tabindex="0"
            aria-label="Justify right button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__align-right">
                <title>align-right</title>
              </use>
            </svg>
          </button>

          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="justifyFull" data-style="textAlign:justify" title="justify Full" tabindex="0"
            aria-label="justify Full button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__menu-closed">
                <title>Unordered List</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Ordered & Unordered List">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="insertOrderedList" data-tag-name="ol" title="Insert ordered list" tabindex="0"
            aria-label="Insert ordered list button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__ordered-list">
                <title>Ordered List</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="insertUnorderedList" data-tag-name="ul" title="Insert unordered list" tabindex="0"
            aria-label="Insert unordered list button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__view-list">
                <title>Unordered List</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Outdent & Indent">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="outdent" title="Outdent" tabindex="0"
            aria-label="Outdent button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__outdent">
                <title>Outdent</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="indent" data-tag-name="blockquote" title="Indent" tabindex="0"
            aria-label="Indent button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__indent">
                <title>indent</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Cut, Copy & Paste">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;" data-action="cut"
            title="Cut" tabindex="0" aria-label="Cut button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__cut">
                <title>cut</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;" data-action="copy"
            title="Copy" tabindex="0" aria-label="Copy button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__copy-alt">
                <title>Copy</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;" id="paste"
            title="Paste" tabindex="0" aria-label="Paste button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__clipboard-notes">
                <title>Paste</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Link & Unlink">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="createLink" data-tag-name="a" title="Insert Link" tabindex="0"
            aria-label="Insert Link button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__chain-link">
                <title>Insert Link</title>
              </use>
            </svg>
          </button>
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="unlink" title="Unlink" tabindex="0"
            aria-label="Unlink button; On Click of this button it will format the Content.">
            <!-- @*Custom Icon *@ -->
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__chain-broken">
                <title>Unlink</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Remove Format & Insert Paragraph">
          <!-- <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;" data-action="insertParagraph" title="Paragraph" aria-label="Paragraph button; On Click of this button it will provide Paragraph in the Content of the Content Area.">@*Custom Icon *@
                  <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
                      <use xlink:href="#dds__paragraph"><title>Paragraph</title></use>
                  </svg></button> -->

          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
            data-action="removeFormat" title="Remove format" tabindex="0"
            aria-label="Remove format button; On Click of this button it will remove format from the Content.">

            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__recycle-bin">
                <title>Remove Format</title>
              </use>
            </svg>
          </button>
        </div>
        <div class="dds__btn-group dds__m-1" role="group" aria-label="Insert Html,Color Code,Table">
          <!-- <input role="button" class="dds__btn dds__btn-secondary" type="file" accept="image/*" id="file"
            style="display: none;" (change)="getImage()">
          <label for="file" class="dds__btn dds__btn-secondary customImg" tabindex="0"
            aria-label="Bold button; On Click of this button it will format the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__camera">
                <title>Image</title>
              </use>
            </svg>
          </label> -->

          <button (click)="Initialize()" id="modalbtn" role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;"
             data-target="#exampleModal" title="Upload File" tabindex="0"
            aria-label="Upload File button; On Click of this button it will show the popup window to Upload File; and on click of insert Button, it will insert the file in Content Area.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__cloud-upload">
                <title>Upload File</title>
              </use>
            </svg>
          </button>
        </div>


        <div class="dds__btn-group dds__m-1" role="group" aria-label="Flip View">
          <button role="button" type="button" class="dds__btn dds__btn-secondary" style="width:40px;" data-action="code"
            title="Show HTML-Code" tabindex="0"
            aria-label="Show HTML-Code button; On Click of this button it will Flip the View of the Content.">
            <svg class="dds__svg-icons" aria-hidden="true" style="height: 18px; width: 18px;">
              <use xlink:href="#dds__metadata">
                <title>Flip View</title>
              </use>
            </svg>
          </button>
        </div>
        <br />
        <div class="dds__btn-group dds__my-1 dds__ml-1 dds__mr-0" role="group" aria-label="Select Controles">
          <select class="dds__form-control" title="Font Family" id="FontFamily" data-action="fontName">
            <option selected="selected" disabled="disabled">Font Family</option>
            <option value="comic sans ms,sans-serif">Comic Sans MS</option>
            <option value="courier new,monospace">Courier New</option>
            <option value="garamond,serif">Garamond</option>
            <option value="georgia,serif">Georgia</option>
            <option value="arial narrow,sans-serif">Narrow </option>
            <option value="times new roman,serif">Sans serif</option>
            <option value="arial,helvetica,sans-serif">Serif</option>
            <option value="tahoma,sans-serif">Tahoma</option>
            <option value="trebuchet ms,sans-serif">Trebuchet MS</option>
            <option value="verdana,sans-serif">Verdana</option>
            <option value="arial black,sans-serif">Wide</option>
          </select>
        </div>
        <div class="dds__btn-group dds__mr-0" role="group" aria-label="Select Controles">
          <select class="dds__form-control" title="Font Size" id="FontSize" data-action="fontSize">
            <option value="1" data-style="font-size:10px;">10px</option>
            <option value="2" data-style="font-size:12px;">12px</option>
            <option value="3" data-style="font-size:14px;">14px</option>
            <option value="4" data-style="font-size:16px;">16px</option>
            <option value="5" data-style="font-size:18px;">18px</option>
            <option value="6" data-style="font-size:21px;">21px</option>
            <option value="7" data-style="font-size:26px;">26px</option>
          </select>
        </div>
        <div class="dds__btn-group dds__mr-0" role="group" aria-label="Header">
          <select class="dds__form-control" title="Format" id="Heading" data-action="formatBlock">
            <option selected="selected" disabled="disabled">Heading</option>
            <option value="h1">Heading 1</option>
            <option value="h2">Heading 2</option>
            <option value="h3">Heading 3</option>
            <option value="h2">Heading 4</option>
            <option value="h3">Heading 5</option>
          </select>
        </div>
        <div class="dds__btn-group dds__mr-0" role="group" aria-label="Color">
          <select class="dds__form-control" title="Font Color" id="FontColor" data-action="foreColor">
            <option selected="selected" disabled="disabled">Font Color</option>
            <option value="#ffffc9" style=" background-color: #ffffc9">
              <div class="color-box" style=" background-color: #ffffc9;">Alert Yellow (alert)</div>
            </option>
            <option value="#cccccc" style=" background-color: #cccccc">
              <div class="color-box" style=" background-color: #cccccc;">Ash (divider, border)</div>
            </option>
            <option value="#b7295a" style=" background-color: #b7295a">
              <div class="color-box" style=" background-color: #b7295a;">Berry (accent)</div>
            </option>
            <option value="#000000" style=" background-color: #000000">
              <div class="color-box" style=" background-color: #000000;">Black (text)</div>
            </option>
            <option value="#444444 " style=" background-color: #444444 ">
              <div class="color-box" style="background-color: #444444;">Carbon</div>
            </option>
            <option value="#edf9ff" style=" background-color: #edf9ff">
              <div class="color-box" style=" background-color: #edf9ff;">Cloud (selected highlight)</div>
            </option>
            <option value="#0076ce" style=" background-color: #0076ce">
              <div class="color-box" style=" background-color: #0076ce;">Dell Blue (primary)</div>
            </option>
            <option value="#c8c9c7" style="background-color: #c8c9c7">
              <div class="color-box" style="background-color: #c8c9c7;">Granite</div>
            </option>
            <option value="#808080" style="background-color: #808080">
              <div class="color-box" style="background-color: #808080;">Gray</div>
            </option>
            <option value="#6ea204" style=" background-color: #6ea204">
              <div class="color-box" style=" background-color: #6ea204;">Green (accent)</div>
            </option>
            <option value="#41b6e6" style=" background-color: #41b6e6">
              <div class="color-box" style=" background-color: #41b6e6;">Light Blue (core)</div>
            </option>
            <option value="#00447c" style=" background-color: #00447c">
              <div class="color-box" style=" background-color: #00447c;">Midnight (core, hover link)</div>
            </option>
            <option value="#f9f9f9" style=" background-color: #f9f9f9">
              <div class="color-box" style=" background-color: #f9f9f9;">Mist (background)</div>
            </option>
            <option value="#767676" style=" background-color: #767676">
              <div class="color-box" style=" background-color: #767676;">Moon (placeholder/disabled text)</div>
            </option>
            <option value="#ee6411" style=" background-color: #ee6411">
              <div class="color-box" style=" background-color: #ee6411;">Orange (accent)</div>
            </option>
            <option value="#408001" style=" background-color: #408001">
              <div class="color-box" style=" background-color: #408001;">Purchase (button)</div>
            </option>
            <option value="#6e2585" style=" background-color: #6e2585">
              <div class="color-box" style=" background-color: #6e2585;">Purple (accent)</div>
            </option>
            <option value="#eeeeee" style=" background-color: #eeeeee">
              <div class="color-box" style=" background-color: #eeeeee;">Quartz (button)</div>
            </option>
            <option value="#ce1126" style=" background-color: #ce1126">
              <div class="color-box" style=" background-color: #ce1126;">Red (accent, errors)</div>
            </option>
            <option value="#006bbd" style=" background-color: #006bbd">
              <div class="color-box" style=" background-color: #006bbd;">Sea Blue (link)</div>
            </option>
            <option value="#cce5f1" style=" background-color: #cce5f1">
              <div class="color-box" style=" background-color: #cce5f1;">Sky (hover highlight)</div>
            </option><option value="#ffffff" style=" background-color: #ffffff">
              <div class="color-box" style=" background-color: #ffffff;">White</div>
            </option>
            <option value="#f2af00" style=" background-color: #f2af00">
              <div class="color-box" style=" background-color: #f2af00;">Yellow (accent)</div>
            </option>
          </select>
        </div>
        <div class="dds__btn-group dds__mr-0" role="group" aria-label="Color">
          <select class="dds__form-control" title="Background Color" id="BackgroundColor" data-action="backColor">
            <option selected="selected" disabled="disabled">Background Color</option>
            <option value="#ffffc9" style=" background-color: #ffffc9">
              <div class="color-box" style=" background-color: #ffffc9;">Alert Yellow (alert)</div>
            </option>
            <option value="#cccccc" style=" background-color: #cccccc">
              <div class="color-box" style=" background-color: #cccccc;">Ash (divider, border)</div>
            </option>
            <option value="#b7295a" style=" background-color: #b7295a">
              <div class="color-box" style=" background-color: #b7295a;">Berry (accent)</div>
            </option>
            <option value="#000000" style=" background-color: #000000">
              <div class="color-box" style=" background-color: #000000;">Black (text)</div>
            </option>
            <option value="#444444 " style=" background-color: #444444 ">
              <div class="color-box" style="background-color: #444444;">Carbon</div>
            </option>
            <option value="#edf9ff" style=" background-color: #edf9ff">
              <div class="color-box" style=" background-color: #edf9ff;">Cloud (selected highlight)</div>
            </option>
            <option value="#0076ce" style=" background-color: #0076ce">
              <div class="color-box" style=" background-color: #0076ce;">Dell Blue (primary)</div>
            </option>
            <option value="#c8c9c7" style="background-color: #c8c9c7">
              <div class="color-box" style="background-color: #c8c9c7;">Granite</div>
            </option>
            <option value="#808080" style="background-color: #808080">
              <div class="color-box" style="background-color: #808080;">Gray</div>
            </option>
            <option value="#6ea204" style=" background-color: #6ea204">
              <div class="color-box" style=" background-color: #6ea204;">Green (accent)</div>
            </option>
            <option value="#41b6e6" style=" background-color: #41b6e6">
              <div class="color-box" style=" background-color: #41b6e6;">Light Blue (core)</div>
            </option>
            <option value="#00447c" style=" background-color: #00447c">
              <div class="color-box" style=" background-color: #00447c;">Midnight (core, hover link)</div>
            </option>
            <option value="#f9f9f9" style=" background-color: #f9f9f9">
              <div class="color-box" style=" background-color: #f9f9f9;">Mist (background)</div>
            </option>
            <option value="#767676" style=" background-color: #767676">
              <div class="color-box" style=" background-color: #767676;">Moon (placeholder/disabled text)</div>
            </option>
            <option value="#ee6411" style=" background-color: #ee6411">
              <div class="color-box" style=" background-color: #ee6411;">Orange (accent)</div>
            </option>
            <option value="#408001" style=" background-color: #408001">
              <div class="color-box" style=" background-color: #408001;">Purchase (button)</div>
            </option>
            <option value="#6e2585" style=" background-color: #6e2585">
              <div class="color-box" style=" background-color: #6e2585;">Purple (accent)</div>
            </option>
            <option value="#eeeeee" style=" background-color: #eeeeee">
              <div class="color-box" style=" background-color: #eeeeee;">Quartz (button)</div>
            </option>
            <option value="#ce1126" style=" background-color: #ce1126">
              <div class="color-box" style=" background-color: #ce1126;">Red (accent, errors)</div>
            </option>
            <option value="#006bbd" style=" background-color: #006bbd">
              <div class="color-box" style=" background-color: #006bbd;">Sea Blue (link)</div>
            </option>
            <option value="#cce5f1" style=" background-color: #cce5f1">
              <div class="color-box" style=" background-color: #cce5f1;">Sky (hover highlight)</div>
            </option><option value="#ffffff" style=" background-color: #ffffff">
              <div class="color-box" style=" background-color: #ffffff;">White</div>
            </option>
            <option value="#f2af00" style=" background-color: #f2af00">
              <div class="color-box" style=" background-color: #f2af00;">Yellow (accent)</div>
            </option>
          </select>
        </div>

      </div>
    </div>
    <hr class="dds__primary_divider dds__m-0">
  </div>
  <div id="parentEditor" class="dds__dell-container-body content-area dds__p-1">
    <div id="visual-view" class="visual-view dds__p-3" placeholder="Type something here..." contenteditable="true"
      style="min-height: 25rem;"></div>
    <textarea id="txtContent" name="Content" class="html-view dds__p-3"
      style="display: none; width: 100%; height: 500px; border: none; resize: vertical;" placeholder="HTML View..."
      readonly="readonly"></textarea>
  </div>


</section>


<div id="contentPopup">
  <div id="exampleModal" tabindex="-1" class="dds__modal dds__fade" role="dialog" aria-labelledby="dds__modal-title1"
    aria-hidden="true" >
    <div class="dds__modal-dialog" role="document" style="max-width:60%;">
      <div class="dds__modal-content">
        <div class="dds__modal-header">
          <h3 class="dds__modal-title" id="dds__modal-title1">Upload File.</h3>
        </div> <button (click)="closeModal()" id="closeButton" class="dds__close" data-dismiss="dds__modal" aria-label="Close"> <span
            class="dds__icons dds__close-x" aria-hidden="true"></span> </button>
        <div class="dds__modal-body" style="height: 400px; overflow-x: hidden; overflow-y: auto;">

        <div *ngIf="loading"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"  >
          <div class="dds__modal-dialog" role="document">
            <div class="dds__modal-content">
              <div class="dds__modal-body dds__text-center">
                <div class="dds__mb-3" id="modalId">
                  <div class="dds__progress-bar">
                    <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
                      role="progressbar" data-showtext="true"></div>
                  </div>
                </div>
                <p>Processing... Please wait.</p>
                <p>{{percentage}}%</p>
              </div>
            </div>
          </div>
        </div>
          <div class="dds__row">
            <div class="dds__col-sm-12 dds__col-md-12 dds__col-lg-12 dds__col-xl-12">
              <div class="dds__tabs-container" id="UploadFileTab">
                <ul class="dds__tabs dds__mb-4" role="tablist" aria-label="Example description of tabs">
                  <li role="none">
                    <button type="button" id="embedURL-tab" class="dds__tab-link dds__active" data-toggle="dds__tab"
                      data-target="#exampleResponsiveTab" role="tab" aria-controls="EmbedURL" aria-selected="true">
                      Embed URL <i class="dds__icons dds__chevron-right dds__tab-icon" aria-hidden="true"></i> </button>
                  </li>
                  <li role="none">
                    <button type="button" id="uploadFile-tab" class="dds__tab-link" tabindex="-1" data-toggle="dds__tab"
                      data-target="#exampleResponsiveTab" role="tab" aria-controls="UploadFile" aria-selected="false">
                      Upload from local <i class="dds__icons dds__chevron-right dds__tab-icon" aria-hidden="true"></i>
                    </button>
                  </li>
                </ul>
                <div class="dds__tab-content">
                  <div id="EmbedURL" class="dds__tab-pane dds__fade dds__active dds__show" role="tabpanel" tabindex="0"
                    aria-labelledby="embedURL-tab">

                    <form data-toggle="dds__form-validation" novalidate="false" [formGroup]="form">
                      <div class="dds__form-group dds__row">
                        <label for="ddlContentType" class="dds__col-3">Select Content Type</label>
                        <div class="dds__col-3">
                          <select formControlName="ddlContentType" id="ddlContentType" class="dds__form-control">
                            <option selected="selected" value="youtube">YouTube</option>
                            <option value="image">Image</option>
                            <option value="other">Other Video Type</option>
                          </select>
                        </div>
                      </div>
                      <div class="dds__form-group dds__row">
                        <label for="txtFileUrl" class="dds__col-3">File URL</label>
                        <div class="dds__col-7">
                          <input type="text" formControlName="txtFileUrl" class="dds__form-control" id="txtFileUrl" required="" aria-invalid="false"
                            aria-describedby="" placeholder="Link (example: https://somewebsite.com/)">
                          <!-- <div class="dds__invalid-feedback" id="txtLinkUrlFeedback">Please enter the File URL.</div> -->
                          <div class="errorMsg" *ngIf="modalError">{{modalError}}</div>
                        </div>
                        <div class="dds__col-2">
                          <button (click)="FileUpload('btnPreview')" [disabled]="!form.get('txtFileUrl').valid" type="button" class="dds__btn dds__btn-purchase" id="btnPreview"
                            aria-label="Preview Button; on click of this buttton, It will show the Preview.">Preview
                            URL</button>
                        </div>
                      </div>
                      <div class="dds__row">
                        <div
                          class="dds__col-12 dds__d-flex dds__align-items-center dds__justify-content-center dds__pb-2"
                          id="PreviewEmbededFile" (ngModel)="preview" >
                        </div>
                      </div>
                      <div class="dds__modal-footer">
                        <button (click)="closeModal()" class="dds__btn dds__btn-secondary" type="button" data-dismiss="dds__modal" tabindex="0"
                          aria-label="Dispose Button; on click of this button, it will Dispose the Modal Box.">Cancel</button>
                        <button (click)="FileUpload('btnInsertHTML')" [disabled]="!form.get('txtFileUrl').valid" class="dds__btn dds__btn-primary" type="button" id="btnInsertHTML" tabindex="0"
                          aria-label="Upload File Button; on click of this button, it will Upload File into RichEditor's Blob.">Submit</button>
                      </div>
                    </form>
                  </div>
                  <div id="UploadFile" class="dds__tab-pane dds__fade" role="tabpanel" tabindex="0"
                        aria-labelledby="uploadFile-tab">
                        <div class="dds__form-row">
                          <div class="dds__col-12">
                            <div class="dds__form-group dds__form-group-upload">
                              <label for="ModalUploadInput">File Upload Label</label>
                              <div class="dds__form-upload-wrapper">
                                <!-- <input onclick="value = null"  (change)="onDocPicked($event)"  type="file" class="dds__form-upload" data-toggle="dds__form-upload"
                                  name="ModalUploadInput" id="ModalUploadInput" data-max-size="100mb"
                                  data-placeholder="Only 'jpeg', 'jpg', 'png', 'ogg', 'mp4', 'webm', 'avi' 100MB maximum"
                                  tabindex="-1" required /> -->
                                <input onclick="value = null"  (change)="onDocPicked($event)"  type="file" class="dds__form-upload" data-toggle="dds__form-upload"
                                  name="ModalUploadInput" id="ModalUploadInput"
                                  data-placeholder="Only 'jpeg', 'jpg', 'png', 'ogg', 'mp4', 'webm', 'avi' extensions are allowed"
                                  tabindex="-1" required />
                                <Button type="button" for="ModalUploadInput" class="dds__form-upload-btn">
                                  <i class="dds__icons dds__upload dds__icon-grid-item"></i>
                                  Upload File
                                </Button>
                              </div>
                              <div class="dds__invalid-feedback" id="ModalUploadInputFeedback">
                                Please upload file.
                              </div>
                              <div class="errorMsg" *ngIf="modalBlobError">{{modalBlobError}}</div>
                            </div>
                            <!-- <div class="dds__modal-footer">
                              <button (click)="closeModal()" class="dds__btn dds__btn-secondary" type="button" data-dismiss="dds__modal" tabindex="0"
                                aria-label="Dispose Button; on click of this button, it will Dispose the Modal Box.">Cancel</button>
                              <button (click)="FileUpload('btnInsertBlob')" class="dds__btn dds__btn-primary" type="button" id="btnInsertBlob" tabindex="0"
                                aria-label="Upload File Button; on click of this button, it will Upload File into RichEditor's Blob.">Submit
                                File</button>
                            </div> -->
                          </div>
                        </div>
                      </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

